<template lang="pug">
  .not-found-page
    .not-found-header
      .not-found-header__nav
        b-icon-arrow-left-square-fill.back-arrow(@click="goBack")
        span.not-found-header__title {{ headerTitle }}
      b-breadcrumb.d-flex.justify-content-start(:items="breadcrumbs")
    .not-found-card
      .not-found-card__content
        .not-found-card__illustration
          svg(
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 486 302"
            fill="none"
            width="486"
            height="302"
          )
            //- Document shadow
            rect(x="120" y="30" width="240" height="260" rx="6" fill="#E8E8E8")
            //- Document body
            rect(x="110" y="20" width="240" height="260" rx="6" fill="#EDEDEE")
            //- Document fold
            path(d="M310 20 L350 60 L310 60 Z" fill="#DDDDE1")
            //- Document lines
            rect(x="140" y="70" width="160" height="8" rx="4" fill="#DDDDE1")
            rect(x="140" y="90" width="180" height="8" rx="4" fill="#DDDDE1")
            rect(x="140" y="130" width="140" height="8" rx="4" fill="#DDDDE1")
            rect(x="140" y="150" width="180" height="8" rx="4" fill="#DDDDE1")
            rect(x="140" y="190" width="160" height="8" rx="4" fill="#DDDDE1")
            rect(x="140" y="210" width="120" height="8" rx="4" fill="#DDDDE1")
            //- Magnifying glass circle (outer)
            circle(cx="260" cy="140" r="72" fill="white" stroke="#23201C" stroke-width="8")
            //- X mark
            line(x1="230" y1="110" x2="290" y2="170" stroke="#23201C" stroke-width="10" stroke-linecap="round")
            line(x1="290" y1="110" x2="230" y2="170" stroke="#23201C" stroke-width="10" stroke-linecap="round")
            //- Magnifying glass handle
            line(x1="315" y1="195" x2="365" y2="245" stroke="#23201C" stroke-width="12" stroke-linecap="round")
            //- Warning triangle
            g(transform="translate(340, 220)")
              polygon(points="15,0 30,26 0,26" fill="#23201C")
              text(x="15" y="22" text-anchor="middle" fill="white" font-size="16" font-weight="bold") !
            //- Decorative dots
            rect(x="370" y="50" width="8" height="8" rx="1" fill="#DDDDE1" transform="rotate(45, 374, 54)")
            rect(x="390" y="80" width="5" height="5" rx="1" fill="#DDDDE1" transform="rotate(45, 392, 82)")
            rect(x="80" y="60" width="6" height="6" rx="1" fill="#DDDDE1" transform="rotate(45, 83, 63)")
            rect(x="60" y="180" width="8" height="8" rx="1" fill="#DDDDE1" transform="rotate(45, 64, 184)")
            rect(x="400" y="160" width="6" height="6" rx="1" fill="#DDDDE1" transform="rotate(45, 403, 163)")
        h2.not-found-card__title {{ mainTitle }}
        p.not-found-card__description
          | {{ descriptionLine1 }}
          br
          | {{ descriptionLine2 }}
        button.not-found-card__button(@click="navigateBack")
          | {{ buttonText }}
</template>

<script>
export default {
  name: 'NotFound',
  props: {
    entityId: {
      type: [String, Number],
      default: null,
    },
    entityType: {
      type: String,
      default: 'page',
      validator: (val) => ['ot', 'ov', 'page'].includes(val),
    },
  },
  computed: {
    headerTitle() {
      const map = {
        ot: 'OT no encontrada',
        ov: 'OV no encontrada',
        page: 'Página no encontrada',
      }
      return map[this.entityType]
    },
    mainTitle() {
      const map = {
        ot: 'Orden de Trabajo no encontrada',
        ov: 'Oportunidad de Venta no encontrada',
        page: 'Página no encontrada',
      }
      return map[this.entityType]
    },
    descriptionLine1() {
      const entity = this.entityLabel
      return `La ${entity} a la que intentas acceder no existe en la base de datos.`
    },
    descriptionLine2() {
      return 'Es posible que el enlace sea incorrecto, que el registro haya sido eliminado o que no tengas los permisos necesarios para visualizarlo.'
    },
    entityLabel() {
      const map = {
        ot: 'OT',
        ov: 'OV',
        page: 'página',
      }
      return map[this.entityType]
    },
    buttonText() {
      const map = {
        ot: 'Volver al listado de OTs',
        ov: 'Volver al listado de OVs',
        page: 'Volver al inicio',
      }
      return map[this.entityType]
    },
    backRoute() {
      const map = {
        ot: '/listar-ordenes',
        ov: '/oportunidad-venta',
        page: '/',
      }
      return map[this.entityType]
    },
    breadcrumbs() {
      return [
        {
          text: 'Inicio',
          to: { path: '/' },
        },
        {
          text: this.headerTitle,
          active: true,
        },
      ]
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    navigateBack() {
      this.$router.push(this.backRoute)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.not-found-page {
  width: 100%;
}

.not-found-header {
  margin-bottom: 1rem;

  &__nav {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: 0.25rem;
  }

  &__title {
    font-size: 20px;
    font-weight: bold;
    color: #23201c;
  }
}

.back-arrow {
  color: $samtek-yellow;
  background-color: #23201c;
  border-radius: 6px;
  font-size: 1.5rem;
  cursor: pointer;
}

.not-found-card {
  background-color: #ffffff;
  border-radius: 8px;
  min-height: calc(100vh - 220px);
  display: flex;
  align-items: center;
  justify-content: center;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    max-width: 650px;
    text-align: center;
    padding: 2rem;
  }

  &__illustration {
    width: 100%;
    max-width: 485px;
    margin-bottom: 1rem;

    svg {
      width: 100%;
      height: auto;
    }
  }

  &__title {
    font-size: 36px;
    font-weight: bold;
    color: #23201c;
    margin: 0;
  }

  &__description {
    font-size: 16px;
    font-weight: 400;
    color: #525252;
    line-height: 1.5;
    margin: 0;
  }

  &__button {
    background-color: #fece2f;
    color: #23201c;
    border: none;
    border-radius: 8px;
    height: 45px;
    padding: 10px 20px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.1s ease;

    &:hover {
      background-color: #e5b823;
    }

    &:active {
      transform: scale(0.98);
    }
  }
}

// Responsive
@media (max-width: 768px) {
  .not-found-card {
    &__title {
      font-size: 24px;
    }

    &__description {
      font-size: 14px;
    }

    &__illustration {
      max-width: 300px;
    }
  }
}
</style>
